/**
 * Every content key the guided report renders (docs/specs/018-ei-guided-reporting.md),
 * relative to `employment-insurance.guided-reporting.`. The BFF sends these
 * as `GuidedText` references; each has an entry in both
 * `public/assets/content-fallback/en.json` and `fr.json`. The FR entries are
 * real French since spec 018's group 7 (a draft pending product-owner
 * sign-off), and no raw key ever renders in the FR locale.
 */
export const GUIDED_REPORTING_KEY_PREFIX = 'employment-insurance.guided-reporting.';

export const GUIDED_REPORTING_CONTENT_KEYS = [
  'employment-insurance.guided-reporting.title',
  'employment-insurance.guided-reporting.subtitle',
  'employment-insurance.guided-reporting.questionEyebrow',
  'employment-insurance.guided-reporting.answerLabel',
  'employment-insurance.guided-reporting.transcriptLabel',
  'employment-insurance.guided-reporting.navStep',
  'employment-insurance.guided-reporting.navEditing',
  'employment-insurance.guided-reporting.navStart',
  'employment-insurance.guided-reporting.back',
  'employment-insurance.guided-reporting.railHeading',
  'employment-insurance.guided-reporting.railCount',
  'employment-insurance.guided-reporting.railComplete',
  'employment-insurance.guided-reporting.railInProgress',
  'employment-insurance.guided-reporting.railHere',
  'employment-insurance.guided-reporting.loadError',
  'employment-insurance.guided-reporting.turnError',
  'employment-insurance.guided-reporting.section.absences',
  'employment-insurance.guided-reporting.section.work',
  'employment-insurance.guided-reporting.section.fullTimeJob',
  'employment-insurance.guided-reporting.section.training',
  'employment-insurance.guided-reporting.section.availability',
  'employment-insurance.guided-reporting.section.otherMoney',
  'employment-insurance.guided-reporting.q.intro',
  'employment-insurance.guided-reporting.q.travel',
  'employment-insurance.guided-reporting.q.travelOver24',
  'employment-insurance.guided-reporting.q.travelDates',
  'employment-insurance.guided-reporting.q.travelReason',
  'employment-insurance.guided-reporting.q.work',
  'employment-insurance.guided-reporting.q.earnWeek1',
  'employment-insurance.guided-reporting.q.earnWeek2',
  'employment-insurance.guided-reporting.q.employerPhones',
  'employment-insurance.guided-reporting.q.stop',
  'employment-insurance.guided-reporting.q.stopReason',
  'employment-insurance.guided-reporting.q.stopReasonOther',
  'employment-insurance.guided-reporting.q.fullTimeJob',
  'employment-insurance.guided-reporting.q.fullTimeJobDate',
  'employment-insurance.guided-reporting.q.training',
  'employment-insurance.guided-reporting.q.trainingWeek1',
  'employment-insurance.guided-reporting.q.trainingWeek2',
  'employment-insurance.guided-reporting.q.trainingAllowanceFrom',
  'employment-insurance.guided-reporting.q.avail',
  'employment-insurance.guided-reporting.q.availDates',
  'employment-insurance.guided-reporting.q.availReason',
  'employment-insurance.guided-reporting.q.availReasonPerDay',
  'employment-insurance.guided-reporting.q.wliWeek1',
  'employment-insurance.guided-reporting.q.wliWeek1Amount',
  'employment-insurance.guided-reporting.q.wliWeek2',
  'employment-insurance.guided-reporting.q.wliWeek2Amount',
  'employment-insurance.guided-reporting.q.other',
  'employment-insurance.guided-reporting.q.otherType',
  'employment-insurance.guided-reporting.q.otherDetails',
  'employment-insurance.guided-reporting.q.otherDetailsMany',
  'employment-insurance.guided-reporting.q.pension',
  'employment-insurance.guided-reporting.opt.yes',
  'employment-insurance.guided-reporting.opt.no',
  'employment-insurance.guided-reporting.opt.intro.nothingChanged',
  'employment-insurance.guided-reporting.opt.intro.someChanged',
  'employment-insurance.guided-reporting.opt.intro.notSure',
  'employment-insurance.guided-reporting.opt.travelOver24.yes',
  'employment-insurance.guided-reporting.opt.travelOver24.no',
  'employment-insurance.guided-reporting.opt.travelReason.vacation',
  'employment-insurance.guided-reporting.opt.travelReason.accompanyMedical',
  'employment-insurance.guided-reporting.opt.travelReason.funeral',
  'employment-insurance.guided-reporting.opt.travelReason.approvedProgram',
  'employment-insurance.guided-reporting.opt.travelReason.jobInterview',
  'employment-insurance.guided-reporting.opt.travelReason.lookForWork',
  'employment-insurance.guided-reporting.opt.travelReason.medicalTreatment',
  'employment-insurance.guided-reporting.opt.travelReason.visitIll',
  'employment-insurance.guided-reporting.opt.travelReason.other',
  'employment-insurance.guided-reporting.opt.stopReason.shortage',
  'employment-insurance.guided-reporting.opt.stopReason.quit',
  'employment-insurance.guided-reporting.opt.stopReason.dismissed',
  'employment-insurance.guided-reporting.opt.stopReason.other',
  'employment-insurance.guided-reporting.opt.fullTime.yes',
  'employment-insurance.guided-reporting.opt.fullTime.no',
  'employment-insurance.guided-reporting.opt.avail.yes',
  'employment-insurance.guided-reporting.opt.avail.no',
  'employment-insurance.guided-reporting.opt.availReason.illness',
  'employment-insurance.guided-reporting.opt.availReason.outsideCanada',
  'employment-insurance.guided-reporting.opt.availReason.other',
  'employment-insurance.guided-reporting.opt.availReason.different',
  'employment-insurance.guided-reporting.opt.other.yes',
  'employment-insurance.guided-reporting.opt.other.no',
  'employment-insurance.guided-reporting.opt.moneyType.vacationPay',
  'employment-insurance.guided-reporting.opt.moneyType.severance',
  'employment-insurance.guided-reporting.opt.moneyType.bonus',
  'employment-insurance.guided-reporting.opt.moneyType.pension',
  'employment-insurance.guided-reporting.opt.moneyType.other',
  'employment-insurance.guided-reporting.opt.moneyType.otherDescribed',
  'employment-insurance.guided-reporting.opt.pension.yes',
  'employment-insurance.guided-reporting.opt.pension.no',
  'employment-insurance.guided-reporting.opt.noTraining.week1',
  'employment-insurance.guided-reporting.opt.noTraining.week2',
  'employment-insurance.guided-reporting.opt.flag.yesCorrect',
  'employment-insurance.guided-reporting.opt.flag.letMeFix',
  'employment-insurance.guided-reporting.opt.flag.reviewEarnings',
  'employment-insurance.guided-reporting.opt.flag.keepAsIs',
  'employment-insurance.guided-reporting.opt.flag.reviewSections',
  'employment-insurance.guided-reporting.opt.flag.updateAvailability',
  'employment-insurance.guided-reporting.opt.flag.updateTravelDates',
  'employment-insurance.guided-reporting.opt.flag.adjustAvailability',
  'employment-insurance.guided-reporting.opt.flag.reviewTraining',
  'employment-insurance.guided-reporting.opt.flag.reviewWli',
  'employment-insurance.guided-reporting.opt.flag.useLastReport',
  'employment-insurance.guided-reporting.opt.flag.keepMyAnswers',
  'employment-insurance.guided-reporting.btn.next',
  'employment-insurance.guided-reporting.btn.addIt',
  'employment-insurance.guided-reporting.btn.confirmWeek1',
  'employment-insurance.guided-reporting.btn.confirmWeek2',
  'employment-insurance.guided-reporting.btn.addEmployers',
  'employment-insurance.guided-reporting.btn.addEmployer',
  'employment-insurance.guided-reporting.btn.removeEmployer',
  'employment-insurance.guided-reporting.btn.confirmDate',
  'employment-insurance.guided-reporting.btn.continue',
  'employment-insurance.guided-reporting.btn.continueCount',
  'employment-insurance.guided-reporting.btn.addAmount',
  'employment-insurance.guided-reporting.field.leftCanada',
  'employment-insurance.guided-reporting.field.returnedCanada',
  'employment-insurance.guided-reporting.field.leftDate',
  'employment-insurance.guided-reporting.field.leftTime',
  'employment-insurance.guided-reporting.field.backDate',
  'employment-insurance.guided-reporting.field.backTime',
  'employment-insurance.guided-reporting.field.hour',
  'employment-insurance.guided-reporting.field.minute',
  'employment-insurance.guided-reporting.field.travelReason',
  'employment-insurance.guided-reporting.field.travelReasonPlaceholder',
  'employment-insurance.guided-reporting.field.pleaseSpecify',
  'employment-insurance.guided-reporting.field.hours',
  'employment-insurance.guided-reporting.field.hoursUnit',
  'employment-insurance.guided-reporting.field.grossEarnings',
  'employment-insurance.guided-reporting.field.selfEmployed',
  'employment-insurance.guided-reporting.field.selfEmploymentEarnings',
  'employment-insurance.guided-reporting.field.employerPhone',
  'employment-insurance.guided-reporting.field.phonePlaceholder',
  'employment-insurance.guided-reporting.field.stopOtherPlaceholder',
  'employment-insurance.guided-reporting.field.fullTimeDate',
  'employment-insurance.guided-reporting.field.hoursAttended',
  'employment-insurance.guided-reporting.field.trainingAllowance',
  'employment-insurance.guided-reporting.field.allowanceFromPlaceholder',
  'employment-insurance.guided-reporting.field.wliAmount',
  'employment-insurance.guided-reporting.field.dayHint',
  'employment-insurance.guided-reporting.field.perDaySelect',
  'employment-insurance.guided-reporting.field.perDayLabel',
  'employment-insurance.guided-reporting.field.otherDescribe',
  'employment-insurance.guided-reporting.field.otherDescribePlaceholder',
  'employment-insurance.guided-reporting.field.fromWhom',
  'employment-insurance.guided-reporting.field.fromPlaceholder',
  'employment-insurance.guided-reporting.field.amountReceived',
  'employment-insurance.guided-reporting.agent.carryForwardLastReport',
  'employment-insurance.guided-reporting.agent.carryForwardApplication',
  'employment-insurance.guided-reporting.agent.letsGo',
  'employment-insurance.guided-reporting.agent.notSure',
  'employment-insurance.guided-reporting.agent.stopRecorded',
  'employment-insurance.guided-reporting.agent.fullTimeRecorded',
  'employment-insurance.guided-reporting.agent.workChanged',
  'employment-insurance.guided-reporting.agent.reviewGuardOne',
  'employment-insurance.guided-reporting.agent.reviewGuardMany',
  'employment-insurance.guided-reporting.note.paidReminder',
  'employment-insurance.guided-reporting.note.fullTimeJob',
  'employment-insurance.guided-reporting.note.availAbsenceReason',
  'employment-insurance.guided-reporting.note.availAbsence',
  'employment-insurance.guided-reporting.note.availDefinition',
  'employment-insurance.guided-reporting.note.availPreselected',
  'employment-insurance.guided-reporting.note.introSwitch',
  'employment-insurance.guided-reporting.flag.sanity.prompt',
  'employment-insurance.guided-reporting.flag.sanity.hoursNoEarnings.headline',
  'employment-insurance.guided-reporting.flag.sanity.hoursNoEarnings.detail',
  'employment-insurance.guided-reporting.flag.sanity.earningsNoHours.headline',
  'employment-insurance.guided-reporting.flag.sanity.earningsNoHours.detail',
  'employment-insurance.guided-reporting.flag.sanity.hoursOverCeiling.headline',
  'employment-insurance.guided-reporting.flag.sanity.hoursOverCeiling.detail',
  'employment-insurance.guided-reporting.flag.selfEmployment.headline',
  'employment-insurance.guided-reporting.flag.selfEmployment.detailCombined',
  'employment-insurance.guided-reporting.flag.selfEmployment.detailSingle',
  'employment-insurance.guided-reporting.flag.selfEmployment.action',
  'employment-insurance.guided-reporting.flag.selfEmployment.prompt',
  'employment-insurance.guided-reporting.flag.classification.headline',
  'employment-insurance.guided-reporting.flag.classification.detail',
  'employment-insurance.guided-reporting.flag.classification.action',
  'employment-insurance.guided-reporting.flag.classification.prompt',
  'employment-insurance.guided-reporting.classification.regularEmployee',
  'employment-insurance.guided-reporting.flag.fullTimeAfterNoWork.headline',
  'employment-insurance.guided-reporting.flag.fullTimeAfterNoWork.detail',
  'employment-insurance.guided-reporting.flag.cascade.headline',
  'employment-insurance.guided-reporting.flag.cascade.detail',
  'employment-insurance.guided-reporting.flag.cascade.detailItem',
  'employment-insurance.guided-reporting.flag.cascade.action',
  'employment-insurance.guided-reporting.flag.cascade.prompt',
  'employment-insurance.guided-reporting.flag.travelReconcile.headlineEveryDay',
  'employment-insurance.guided-reporting.flag.travelReconcile.headlineSomeDays',
  'employment-insurance.guided-reporting.flag.travelReconcile.detailEveryDay',
  'employment-insurance.guided-reporting.flag.travelReconcile.detailSomeDays',
  'employment-insurance.guided-reporting.flag.travelReconcile.noWeekdays',
  'employment-insurance.guided-reporting.flag.travelReconcile.action',
  'employment-insurance.guided-reporting.flag.travelReconcile.prompt',
  'employment-insurance.guided-reporting.flag.reasonMismatch.headline',
  'employment-insurance.guided-reporting.flag.reasonMismatch.detailOne',
  'employment-insurance.guided-reporting.flag.reasonMismatch.detailMany',
  'employment-insurance.guided-reporting.flag.reasonMismatch.action',
  'employment-insurance.guided-reporting.flag.reasonMismatch.prompt',
  'employment-insurance.guided-reporting.flag.staleAvailability.headline',
  'employment-insurance.guided-reporting.flag.staleAvailability.detailEveryDay',
  'employment-insurance.guided-reporting.flag.staleAvailability.detailSomeDays',
  'employment-insurance.guided-reporting.flag.staleAvailability.action',
  'employment-insurance.guided-reporting.flag.staleAvailability.prompt',
  'employment-insurance.guided-reporting.flag.trainingWli.headline',
  'employment-insurance.guided-reporting.flag.trainingWli.detailHours',
  'employment-insurance.guided-reporting.flag.trainingWli.detailAllowance',
  'employment-insurance.guided-reporting.flag.trainingWli.action',
  'employment-insurance.guided-reporting.flag.trainingWli.prompt',
  'employment-insurance.guided-reporting.flag.pension.headline',
  'employment-insurance.guided-reporting.flag.pension.detailMore',
  'employment-insurance.guided-reporting.flag.pension.detailLess',
  'employment-insurance.guided-reporting.flag.pension.action',
  'employment-insurance.guided-reporting.error.prefix',
  'employment-insurance.guided-reporting.error.workHardStop',
  'employment-insurance.guided-reporting.error.travelMissing',
  'employment-insurance.guided-reporting.error.part.leftDate',
  'employment-insurance.guided-reporting.error.part.leftTime',
  'employment-insurance.guided-reporting.error.part.backDate',
  'employment-insurance.guided-reporting.error.part.backTime',
  'employment-insurance.guided-reporting.error.travelOrder',
  'employment-insurance.guided-reporting.error.travelReasonRequired',
  'employment-insurance.guided-reporting.error.travelOtherRequired',
  'employment-insurance.guided-reporting.error.dateOutsidePeriod',
  'employment-insurance.guided-reporting.error.phoneDigits',
  'employment-insurance.guided-reporting.error.phoneRequired',
  'employment-insurance.guided-reporting.error.stopOtherRequired',
  'employment-insurance.guided-reporting.error.fullTimeDateRequired',
  'employment-insurance.guided-reporting.error.trainingHardStop',
  'employment-insurance.guided-reporting.error.allowanceFromRequired',
  'employment-insurance.guided-reporting.error.availDatesRequired',
  'employment-insurance.guided-reporting.error.perDayRequired',
  'employment-insurance.guided-reporting.error.wliAmountWeek1',
  'employment-insurance.guided-reporting.error.wliAmountWeek2',
  'employment-insurance.guided-reporting.error.otherTypeRequired',
  'employment-insurance.guided-reporting.error.otherDescribeRequired',
  'employment-insurance.guided-reporting.error.otherFromRequired',
  'employment-insurance.guided-reporting.error.otherAmountRequired',
  'employment-insurance.guided-reporting.answer.text',
  'employment-insurance.guided-reporting.answer.dash',
  'employment-insurance.guided-reporting.answer.yes',
  'employment-insurance.guided-reporting.answer.no',
  'employment-insurance.guided-reporting.answer.number',
  'employment-insurance.guided-reporting.answer.money',
  'employment-insurance.guided-reporting.answer.date',
  'employment-insurance.guided-reporting.answer.days',
  'employment-insurance.guided-reporting.answer.list',
  'employment-insurance.guided-reporting.answer.week',
  'employment-insurance.guided-reporting.answer.weekSelfEmployed',
  'employment-insurance.guided-reporting.answer.employers',
  'employment-insurance.guided-reporting.answer.travelDates',
  'employment-insurance.guided-reporting.answer.fullTimeStarted',
  'employment-insurance.guided-reporting.answer.trainingWeek',
  'employment-insurance.guided-reporting.answer.trainingWeekAllowance',
  'employment-insurance.guided-reporting.answer.otherDetail',
  'employment-insurance.guided-reporting.summary.absencesNo',
  'employment-insurance.guided-reporting.summary.absencesYes',
  'employment-insurance.guided-reporting.summary.absencesOver24',
  'employment-insurance.guided-reporting.summary.absencesUnder24',
  'employment-insurance.guided-reporting.summary.workNo',
  'employment-insurance.guided-reporting.summary.workYes',
  'employment-insurance.guided-reporting.summary.workYesEmployer',
  'employment-insurance.guided-reporting.summary.workYesEmployers',
  'employment-insurance.guided-reporting.summary.week',
  'employment-insurance.guided-reporting.summary.weekOneHour',
  'employment-insurance.guided-reporting.summary.weekNoWork',
  'employment-insurance.guided-reporting.summary.fullTimeNo',
  'employment-insurance.guided-reporting.summary.fullTimeYes',
  'employment-insurance.guided-reporting.summary.fullTimeYesDate',
  'employment-insurance.guided-reporting.summary.trainingNo',
  'employment-insurance.guided-reporting.summary.trainingYes',
  'employment-insurance.guided-reporting.summary.trainingYesAllowance',
  'employment-insurance.guided-reporting.summary.availYes',
  'employment-insurance.guided-reporting.summary.availNo',
  'employment-insurance.guided-reporting.summary.availNoReason',
  'employment-insurance.guided-reporting.summary.availNoReasonWli',
  'employment-insurance.guided-reporting.summary.wliBoth',
  'employment-insurance.guided-reporting.summary.wliWeek1',
  'employment-insurance.guided-reporting.summary.wliWeek2',
  'employment-insurance.guided-reporting.summary.otherNo',
  'employment-insurance.guided-reporting.summary.otherYes',
  'employment-insurance.guided-reporting.summary.otherItems',
  'employment-insurance.guided-reporting.summary.otherItemsTotal',
  'employment-insurance.guided-reporting.describe.trainingNo',
  'employment-insurance.guided-reporting.describe.trainingYes',
  'employment-insurance.guided-reporting.describe.availYes',
  'employment-insurance.guided-reporting.describe.availNo',
  'employment-insurance.guided-reporting.describe.availNoUnspecified',
  'employment-insurance.guided-reporting.describe.availUnanswered',
  'employment-insurance.guided-reporting.describe.otherNo',
  'employment-insurance.guided-reporting.describe.otherYes',
  'employment-insurance.guided-reporting.describe.otherItems',
  'employment-insurance.guided-reporting.describe.otherItem',
  'employment-insurance.guided-reporting.review.title',
  'employment-insurance.guided-reporting.review.period',
  'employment-insurance.guided-reporting.review.prefilledLastReport',
  'employment-insurance.guided-reporting.review.prefilledApplication',
  'employment-insurance.guided-reporting.review.change',
  'employment-insurance.guided-reporting.review.changeLabel',
  'employment-insurance.guided-reporting.review.introHeading',
  'employment-insurance.guided-reporting.review.q.intro',
  'employment-insurance.guided-reporting.review.q.travel',
  'employment-insurance.guided-reporting.review.q.travelOver24',
  'employment-insurance.guided-reporting.review.q.travelDetails',
  'employment-insurance.guided-reporting.review.q.worked',
  'employment-insurance.guided-reporting.review.q.week1',
  'employment-insurance.guided-reporting.review.q.week2',
  'employment-insurance.guided-reporting.review.q.employerPhone',
  'employment-insurance.guided-reporting.review.q.employerPhoneN',
  'employment-insurance.guided-reporting.review.q.stopped',
  'employment-insurance.guided-reporting.review.q.stopReason',
  'employment-insurance.guided-reporting.review.q.fullTime',
  'employment-insurance.guided-reporting.review.q.fullTimeDate',
  'employment-insurance.guided-reporting.review.q.training',
  'employment-insurance.guided-reporting.review.q.trainingHoursWeek1',
  'employment-insurance.guided-reporting.review.q.trainingAllowanceWeek1',
  'employment-insurance.guided-reporting.review.q.trainingHoursWeek2',
  'employment-insurance.guided-reporting.review.q.trainingAllowanceWeek2',
  'employment-insurance.guided-reporting.review.q.trainingAllowanceFrom',
  'employment-insurance.guided-reporting.review.q.avail',
  'employment-insurance.guided-reporting.review.q.availDates',
  'employment-insurance.guided-reporting.review.q.availReason',
  'employment-insurance.guided-reporting.review.q.wli',
  'employment-insurance.guided-reporting.review.q.sick',
  'employment-insurance.guided-reporting.review.q.other',
  'employment-insurance.guided-reporting.review.q.otherItem',
  'employment-insurance.guided-reporting.review.q.otherItemN',
  'employment-insurance.guided-reporting.review.a.travelYes',
  'employment-insurance.guided-reporting.review.a.over24Yes',
  'employment-insurance.guided-reporting.review.a.over24No',
  'employment-insurance.guided-reporting.review.a.travelDetails',
  'employment-insurance.guided-reporting.review.a.workedYes',
  'employment-insurance.guided-reporting.review.a.workedNo',
  'employment-insurance.guided-reporting.review.a.hours',
  'employment-insurance.guided-reporting.review.a.availYes',
  'employment-insurance.guided-reporting.review.a.availNo',
  'employment-insurance.guided-reporting.review.a.wliReceived',
  'employment-insurance.guided-reporting.review.a.wliNone',
  'employment-insurance.guided-reporting.review.a.otherItem',
  'employment-insurance.guided-reporting.review.a.dayReason',
  'employment-insurance.guided-reporting.review.attest.heading',
  'employment-insurance.guided-reporting.review.attest.s1',
  'employment-insurance.guided-reporting.review.attest.s2',
  'employment-insurance.guided-reporting.review.attest.s3',
  'employment-insurance.guided-reporting.review.attest.s4',
  'employment-insurance.guided-reporting.review.attest.s5',
  'employment-insurance.guided-reporting.review.attest.confirm',
  'employment-insurance.guided-reporting.review.backToEdit',
  'employment-insurance.guided-reporting.review.submit',
  'employment-insurance.guided-reporting.review.submitError',
  'employment-insurance.guided-reporting.confirm.title',
  'employment-insurance.guided-reporting.confirm.submitted',
  'employment-insurance.guided-reporting.confirm.receivedHeading',
  'employment-insurance.guided-reporting.confirm.receivedBody',
  'employment-insurance.guided-reporting.confirm.nextHeading',
  'employment-insurance.guided-reporting.confirm.nextBody',
  'employment-insurance.guided-reporting.confirm.claimHeading',
  'employment-insurance.guided-reporting.confirm.claimBody',
  'employment-insurance.guided-reporting.confirm.backToReports',
] as const;
